/*
 * ANIME CRUSH — SHOP PAGES: savings badge follows the chosen variant.
 *
 * snippets/product-meta renders "Save N%" for the first variant plus a map
 * { variantId: [price, compareAt] } in cents. When the customer picks another
 * size or colour, the form's <select name="id"> changes (ac-variant.js sets it
 * and dispatches `change`; Prestige dispatches `variant:changed`). Either one
 * repaints the badge. Only a percentage is written, never money, so the
 * currency converter and the money format are never involved.
 */
(function () {
  'use strict';
  var badge = document.querySelector('[data-ac-save]');
  var dataEl = document.querySelector('[data-ac-save-variants]');
  if (!badge || !dataEl) return;
  var pctEl = badge.querySelector('[data-ac-save-pct]');
  var map;
  try { map = JSON.parse(dataEl.textContent); } catch (e) { return; }

  function paint(id) {
    var row = map[String(id)];
    if (!row) return;
    var price = row[0], compare = row[1];
    var pct = compare > price ? Math.floor((compare - price) * 100 / compare) : 0;
    if (pct >= 1) { pctEl.textContent = String(pct); badge.hidden = false; }
    else { badge.hidden = true; }
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.name === 'id' && t.closest && t.closest('form[action*="/cart/add"]')) paint(t.value);
  });
  document.addEventListener('variant:changed', function (e) {
    if (e.detail && e.detail.variant) paint(e.detail.variant.id);
  });
})();

/*
 * STICKY ADD TO CART (phones and tablets).
 *
 * On a phone the buy button scrolls away after the first screen, and a shopper
 * reading the description or the size guide has to scroll back to buy. This
 * bar appears only while the real button is off screen, and it does nothing
 * of its own: it clicks the real Add to Cart, so the form posts exactly the
 * variant the customer chose (the select stays the single source of truth,
 * see ac-variant.js). Its label and price are COPIED from the real button's
 * text, never formatted here. Sold out or unavailable: the bar hides.
 */
(function () {
  'use strict';
  var atc = document.querySelector('.Product__Info .ProductForm__AddToCart');
  if (!atc || !('IntersectionObserver' in window)) return;
  var mq = window.matchMedia('(max-width: 1007px)');

  var bar = document.createElement('div');
  bar.className = 'AcStickyBuy';
  bar.hidden = true;
  var btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'AcStickyBuy__Button';
  bar.appendChild(btn);
  document.body.appendChild(bar);

  var offscreen = false;
  function sync() {
    var text = (atc.innerText || atc.textContent || '').replace(/\s+/g, ' ').trim();
    btn.textContent = text;
    var show = mq.matches && offscreen && !atc.disabled && text !== '';
    bar.hidden = !show;
    document.body.classList.toggle('ac-sticky-buy-on', show);
  }

  new IntersectionObserver(function (entries) {
    var r = entries[0];
    offscreen = !r.isIntersecting && r.boundingClientRect.top < 0;
    sync();
  }).observe(atc);

  new MutationObserver(sync).observe(atc, { attributes: true, childList: true, subtree: true, characterData: true });
  if (mq.addEventListener) mq.addEventListener('change', sync);

  btn.addEventListener('click', function () { atc.click(); });
})();
